export const appVersion = __APP_VERSION_FULL__;
